import { orchestrator } from 'satcheljs';
import { onDateRangeUpdated } from 'owa-calendar-events-loader';
import { isListCalendarCacheId } from '../selectors/agendaStoreSelectors';
import { updateTopOfListIndex } from '../actions/internalActions';
import { refreshScrollingForDateRange } from './refreshScrollingForDateRange';

export const onDateRangeUpdatedOrchestrator = orchestrator(onDateRangeUpdated, actionMessage => {
    const { dateRange, eventsCacheLockId } = actionMessage;
    const isStoredListCalendarCacheId = isListCalendarCacheId(eventsCacheLockId);
    if (isStoredListCalendarCacheId.value) {
        const agendaScenarioId = isStoredListCalendarCacheId.scenarioId;
        /* TODO VSO 47868
         * We reset the top of the list, so that if the list is unmounted,
         * it will not scroll to the saved top when restoreSaveScrollPosition
         * is called in componentDidMount. This is to mitigate the affects of VSO: 47868,
         * but it is definitely a workaround/ hack.
         * */
        updateTopOfListIndex(null, agendaScenarioId);
        refreshScrollingForDateRange(agendaScenarioId, dateRange);
    }
});
